import { DialogService, GridButton } from '@eforall/dashboard';
import { AccTeamDialogDataService } from '../../acc-team-dialog-data.service';
import { AddMentorDialog, AddMentorDialogContextData } from '../add-mentor/add-mentor.dialog';


export function getButtons(dialogService: DialogService, dialogDataService: AccTeamDialogDataService): GridButton[] {

	const buttons: GridButton[] = [];

	const addMentor: GridButton = {
		iconClass: 'fa-plus',
		label: 'Add Mentor',
		execute: async () => {
			const data = dialogDataService.dialogData();
			if (!data) return;

			const dialogData: AddMentorDialogContextData = {
				accTeamId: data.accTeamId,
				teamName: data.name,
				trimesterId: data.trimesterId,
				accId: data.accId,
				languageId: data.languageId,
			};
			await dialogService.showCustom(AddMentorDialog, { data: dialogData }, 500, 400);
			await dialogDataService.reloadData();
		}
	};

	if (dialogDataService.canEdit() || dialogDataService.canEditMentors()) {
		buttons.push(addMentor);
	}

	return buttons;
}